import { Ref } from 'react'

import { CommonHorizontalArrow7Icon, ProfileEditIcon, CommonVerifiedIcon } from '@local/assets/icons'
import { CLICK_CODE } from '@local/utils'

import Image from '@web/components/Image'
import { DEFAULT_PROFILE_IMAGE } from '@web/libs/constants'
import Clickable from '@web/ui/components/Clickable'

import styles from './Profile.module.scss'

export interface ProfileProps {
  /**
   * 로그인 여부
   */
  login?: boolean
  /**
   * 프로필 이미지
   */
  profileImageUrl?: string
  /**
   * 프로필 띠 이미지
   */
  borderImageUrl?: string
  /**
   * 플레이스닉네임
   */
  nickname: string
  /**
   * 리뷰 수
   */
  reviewCount: number
  /**
   * 리뷰 클릭시 콜백
   */
  onClickReviewCount?: () => void
  /**
   * 프로필 이미지 클릭시 콜백
   */
  onClickProfile?: () => void
  /**
   * 프로필 설정 유도 툴팁 노출 여부
   */
  showTooltip?: boolean
  /**
   * 툴팁 닫기시 콜백
   */
  onCloseTooltip?: () => void
  /**
   * 툴팁 ref
   */
  tooltipRef?: Ref<HTMLDivElement>
  /**
   * 공식 뱃지
   */
  isOfficial?: boolean
}
export default function Profile({
  nickname,
  borderImageUrl,
  login,
  profileImageUrl,
  reviewCount,
  onClickReviewCount,
  onClickProfile,
  showTooltip = false,
  tooltipRef,
  isOfficial,
}: ProfileProps) {
  return (
    <div className={styles.profile_area}>
      <div className={styles.inner}>
        {!login ? (
          <div className={styles.profile_wrapper}>
            {/* 프로필 이미지 영역 */}
            <div className={styles.profile_thumb_area}>
              <Clickable className={styles.thumb_area} onClick={onClickProfile}>
                <Image className={styles.img} src={DEFAULT_PROFILE_IMAGE} width="44" height="44" alt="프로필" />
              </Clickable>
            </div>

            {/* 프로필 정보 영역 */}
            <div className={styles.profile_info_area}>
              <div className={styles.name_area}>
                <Clickable className={styles.name} onClick={onClickProfile}>
                  로그인해주세요.
                  <CommonHorizontalArrow7Icon className={styles.icon_arrow} aria-hidden="true" />
                </Clickable>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.profile_wrapper}>
            {/* 프로필 이미지 영역 */}
            <div className={styles.profile_thumb_area}>
              <Clickable className={styles.thumb_area} onClick={onClickProfile} nClickCode={CLICK_CODE['gnb.profile']}>
                <Image
                  className={styles.img}
                  src={profileImageUrl ?? DEFAULT_PROFILE_IMAGE}
                  width="44"
                  height="44"
                  alt="프로필"
                />
                {borderImageUrl && (
                  <Image
                    className={styles.img_profile_border}
                    src={borderImageUrl}
                    width="66"
                    height="66"
                    alt="프로필 띠"
                  />
                )}
                <span className={styles.edit}>
                  <ProfileEditIcon className={styles.icon} aria-hidden="true" />
                  <span className="place_blind">수정</span>
                </span>
              </Clickable>

              {/* 툴팁 레이어 */}
              {showTooltip && (
                <div className={styles.ly_tooltip} ref={tooltipRef}>
                  <em>내 플레이스 프로필</em>을 꾸며보세요!
                </div>
              )}
            </div>

            {/* 프로필 정보 영역 */}
            <div className={styles.profile_info_area}>
              <div className={styles.name_area}>
                <Clickable className={styles.name} onClick={onClickProfile} nClickCode={CLICK_CODE['gnb.profile']}>
                  {nickname}
                  {isOfficial && <CommonVerifiedIcon className={styles.icon_official} aria-hidden="true" />}
                </Clickable>
              </div>
              {reviewCount > 0 && (
                <div className={styles.count_area}>
                  <Clickable
                    className={styles.item}
                    onClick={onClickReviewCount}
                    nClickCode={CLICK_CODE['gnb.myprofilereview']}
                  >
                    리뷰 {reviewCount.toLocaleString()}
                    <CommonHorizontalArrow7Icon className={styles.icon_arrow} aria-hidden="true" />
                  </Clickable>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
